import { css } from '@emotion/react';
import MentorRequestHeader from './mentor-request-header';
import MentorRequestDescription from './mentor-request-description';
import MentorRequestMessageInput from './mentor-request-message-input';
import MentorRequestSent from './mentor-request-sent';
import MentorRequestSubmitButton from './mentor-request-submit-button';
import MentorRequestContinueBrowsingButton from './mentor-request-continue-browsing-button';
import MentorRequestWithdrawRequestButton from './mentor-request-withdraw-request-button';
import MentorRequestApprovalActions from './mentor-request-approval-actions';

const styles = css`
  max-width: 450px;
`;

const MentorRequestBody = ({ children }: { children: React.ReactNode }) => (
  <div css={styles} className='mr-5 p-4 modal-panel'>
    {children}
  </div>
);

const MentorRequestContainer = Object.assign(MentorRequestBody, {
  Header: MentorRequestHeader,
  Description: MentorRequestDescription,
  MessageInput: MentorRequestMessageInput,
  Request: MentorRequestSent,
  ContinueBrowsing: MentorRequestContinueBrowsingButton,
  WithdrawRequest: MentorRequestWithdrawRequestButton,
  SubmitRequest: MentorRequestSubmitButton,
  ApprovalActions: MentorRequestApprovalActions,
});

export default MentorRequestContainer;
